import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PendingHorseShowEntryService } from '../../providers/pending-horse-show-entry.service';
import { HorseService } from '../../providers/horse.service';
import { PersonService } from '../../providers/person.service';
import { AddHorseViewService } from '../horses/providers/add-horse-view.service';
import { AddPersonViewService } from '../people/providers/add-person-view.service';
import { CheckoutService } from '../../providers/checkout.service';
import { AccessCodeService } from '../../providers/access-code.service';
import { Horse } from '../../models/horse';
import { Person } from '../../models/person';

import { faClipboardList, faShoppingBasket, faPenAlt, faEdit, faUser, faUsers, faSpinner, faShareSquare, faShoppingCart, faTrash, faDollarSign, faLock } from '@fortawesome/fontawesome-pro-regular';
import { faHorseHead, faEllipsisH, faCashRegister, faDoNotEnter, faCopy, faUserTie, faUserCowboy, faUserHardHat } from '@fortawesome/pro-regular-svg-icons';

import { SmsAbstractAppPage } from '../sms-abstract-app-page';

import { ModalEnterAccessCodeComponent } from '../modal-enter-access-code/modal-enter-access-code.component';
import { ModalEditHorseOnEntryComponent } from '../modal-edit-horse-on-entry/modal-edit-horse-on-entry.component';
import { ModalEditPersonOnEntryComponent } from '../modal-edit-person-on-entry/modal-edit-person-on-entry.component';
import { ModalChooseHorseComponent } from '../horses/modal-choose-horse/modal-choose-horse.component';
import { ModalChoosePersonComponent } from '../people/modal-choose-person/modal-choose-person.component';
import { ModalChooseRiderComponent } from '../modal-choose-rider/modal-choose-rider.component';
import { ModalEditCompetitionsComponent } from '../modal-edit-competitions/modal-edit-competitions.component';
import { ModalViewPendingEntryComponent } from '../modal-view-pending-entry/modal-view-pending-entry.component';
import { ModalEditPayeeOnEntryComponent } from '../modal-edit-payee-on-entry/modal-edit-payee-on-entry.component';
import { ModalEditBillingItemsComponent } from '../modal-edit-billing-items/modal-edit-billing-items.component';
import { ModalEditSignaturesOnEntryComponent } from '../modal-edit-signatures-on-entry/modal-edit-signatures-on-entry.component';
import { ModalConfirmDialogComponent } from '../modal-confirm-dialog/modal-confirm-dialog.component';
import { ModalPayBalanceComponent } from '../modal-pay-balance/modal-pay-balance.component';
import { ModalEditMiscOnEntryComponent } from '../modal-edit-misc-on-entry/modal-edit-misc-on-entry.component';
import { ModalPaymentReceiptComponent } from '../modal-payment-receipt/modal-payment-receipt.component';
import { ModalCopyCircuitEntryComponent } from '../modal-copy-circuit-entry/modal-copy-circuit-entry.component';
import { ModalSelectCircuitShowsComponent } from '../modal-select-circuit-shows/modal-select-circuit-shows.component';
import { AccountHorseShowEntriesView } from '../../models/account_horse_show_entries_view';
import { AccountHorseShowEntryViewService } from '../../providers/account-horse-show-entry-view.service';
import { AccountEntryView } from '../../models/account_entry_view';
import { AccountCompetitionEntryView } from '../../models/account_competition_entry_view';
import { I_competition_entry } from '../../models/i_competition_entry.interface';
import { Statement } from '../../models/accounting/statement';

@Component({
  standalone: false,
  selector: 'app-my-entries',
  templateUrl: './my-entries.component.html',
  styleUrls: ['./my-entries.component.css']
})
export class MyEntriesComponent extends SmsAbstractAppPage implements OnInit {
  faChessKnightAlt = faHorseHead;
  faClipboardList = faClipboardList;
  faShoppingBasket = faShoppingBasket;
  faPenAlt = faPenAlt;
  faUserTie = faUserTie;
  faUserCowboy = faUserCowboy;
  faUsers = faUsers;
  faEdit = faEdit;
  faSpinner = faSpinner;
  faShareSquare = faShareSquare;
  faShoppingCart = faShoppingCart;
  faTrash = faTrash;
  faEye = faEllipsisH;
  faUser = faUser;
  faUserHardHat = faUserHardHat;
  faDollarSign = faDollarSign;
  faCashRegister = faCashRegister;
  faDoNotEnter = faDoNotEnter;
  faCopy = faCopy;
  faLock = faLock;
  protected readonly faHorseHead = faHorseHead;

  cart_search_in_progress: boolean = false;
  history_search_in_progress: boolean = false;
  submission_in_progress: boolean = false;

  unsubmittedHorseShows: AccountHorseShowEntriesView[] = [];
  submittedHorseShows: AccountHorseShowEntriesView[] = [];
  submittedPage: number = 0;
  unsubmittedPage: number = 0;
  pageSize: number = 10;
  totalUnsubmittedEntryShows: number = 0;
  totalSubmittedEntryShows: number = 0;

  accessCodeUnlockableShowIds: Set<string> = new Set();

  constructor(
    private accountHorseShowEntryViewService: AccountHorseShowEntryViewService,
    private pendingHorseShowEntryService: PendingHorseShowEntryService,
    private horseService: HorseService,
    private personService: PersonService,
    private addHorseViewService: AddHorseViewService,
    private addPersonViewService: AddPersonViewService,
    private modal: NgbModal,
    private checkoutService: CheckoutService,
    private accessCodeService: AccessCodeService,
    private router: Router
  ) {
    super();
  }

  ngOnInit() {
    this.cart_search_in_progress = true;
    this.history_search_in_progress = true;

    this.accountHorseShowEntryViewService.getHorseShowEntryViewList(false, this.pageSize, this.unsubmittedPage).then(horseShowList => {
      this.unsubmittedHorseShows = horseShowList.horseShowAndEntriesViewList;
      this.totalUnsubmittedEntryShows = horseShowList.totalCount;
      this.cart_search_in_progress = false;
      this.loadAccessCodeData();
    }).catch(error => {
      this.handleError(error);
      this.cart_search_in_progress = false;
    });

    this.accountHorseShowEntryViewService.getHorseShowEntryViewList(true, this.pageSize, this.submittedPage).then(horseShowList => {
      this.submittedHorseShows = horseShowList.horseShowAndEntriesViewList;
      this.totalSubmittedEntryShows = horseShowList.totalCount;
      this.history_search_in_progress = false;
    }).catch(error => {
      this.handleError(error);
      this.history_search_in_progress = false;
    });
  }

  private loadAccessCodeData(): void {
    Promise.all([
      this.accessCodeService.getAccessCodeEntryTypeShowIds(),
      this.accessCodeService.getAccessList()
    ]).then(([unlockableIds, accessList]) => {
      this.accessCodeUnlockableShowIds = new Set(unlockableIds);
      const userAccessShowIds = new Set(accessList.map(a => a.horse_show_id));

      this.unsubmittedHorseShows.forEach(horseShow => {
        if (this.accessCodeUnlockableShowIds.has(horseShow.horseShowId) && userAccessShowIds.has(horseShow.horseShowId)) {
          horseShow.entries.forEach(entry => {
            if (!entry.entryAvailable) {
              entry.entryAvailable = true;
            }
          });
        }
      });
    }).catch(() => {
      // non-critical — access code data is best-effort
    });
  }

  handleUnlockEntry(horseShow: AccountHorseShowEntriesView): void {
    const modal_ref = this.modal.open(ModalEnterAccessCodeComponent, { size: 'lg' });
    modal_ref.componentInstance.horse_show_id = horseShow.horseShowId;
    modal_ref.componentInstance.horse_show_unlocked$.subscribe((responding_id: string) => {
      if (responding_id === horseShow.horseShowId) {
        this.accessCodeService.checkInvitationCodeAccess(horseShow.horseShowId).then(unlocked => {
          if (unlocked) {
            horseShow.entries.forEach(entry => {
              if (!entry.entryAvailable) {
                entry.entryAvailable = true;
              }
            });
          }
          modal_ref.close();
        }).catch(error => {
          this.handleError(error);
          modal_ref.close();
        });
      }
    });
  }

  unSubmittedPageChanged(event: any): void {
    this.unsubmittedPage = event;
    this.cart_search_in_progress = true;
    this.accountHorseShowEntryViewService.getHorseShowEntryViewList(false, this.pageSize, (this.unsubmittedPage - 1) * this.pageSize).then(unsubmittedHorseShowList => {
      this.unsubmittedHorseShows = unsubmittedHorseShowList.horseShowAndEntriesViewList;
      this.cart_search_in_progress = false;
      this.loadAccessCodeData();
    });
  }

  submittedPageChanged(event: any): void {
    this.submittedPage = event;
    this.history_search_in_progress = true;
    this.accountHorseShowEntryViewService.getHorseShowEntryViewList(true, this.pageSize, (this.submittedPage - 1) * this.pageSize).then(submittedHorseShowList => {
      this.submittedHorseShows = submittedHorseShowList.horseShowAndEntriesViewList;
      this.history_search_in_progress = false;
    });
  }

  handleEditOwner(entryView: AccountEntryView) {
    this.handleEditPerson(entryView, entryView.ownerPersonId, 'OWNER');
  }

  handleEditTrainer(entryView: AccountEntryView) {
    this.handleEditPerson(entryView, entryView.trainerPersonId, 'TRAINER');
  }

  handleEditRiders(entryView: AccountEntryView) {
    this.pendingHorseShowEntryService.getRiderList(entryView.entryId).then(rider_list => {
      let modal_riders = this.modal.open(ModalChooseRiderComponent, { size: 'lg' });
      modal_riders.componentInstance.rider_list = rider_list;

      modal_riders.componentInstance.rider_selected$.subscribe(rider => {
        modal_riders.close();
        this.handleEditPerson(entryView, rider.id, 'RIDER');
      }, error => {
        modal_riders.close();
        this.handleError(error);
      });

      modal_riders.componentInstance.add_rider$.subscribe(event => {
        modal_riders.close();
        let modal_ref_person = this.modal.open(ModalChoosePersonComponent, { size: 'lg' });
        modal_ref_person.componentInstance.role = 'RIDER';
        modal_ref_person.componentInstance.person_selected$.subscribe((selected_person: Person) => {
          this.pendingHorseShowEntryService.addRiderToEntry(entryView.entryId, selected_person.id).then(response => {
            modal_ref_person.close();
          }).catch(error => {
            modal_ref_person.close();
            this.handleError(error);
          });
        });
        modal_ref_person.componentInstance.add_new_selected$.subscribe(response => {
          if (response) {
            modal_ref_person.close();
            this.addPersonViewService.doAddPerson().then(new_person => {
              this.personService.create(new_person).then(ret_person => {
                this.pendingHorseShowEntryService.addRiderToEntry(entryView.entryId, ret_person.id).then(response => {
                  modal_ref_person.close();
                }).catch(error => {
                  modal_ref_person.close();
                  this.handleError(error);
                });
              }).catch(error => { this.handleError(error); });
            }).catch(error => { this.handleError(error); });
          }
        }, error => { this.handleError(error); });
      }, error => {
        modal_riders.close();
        this.handleError(error);
      });
    }).catch(error => { this.handleError(error); });
  }

  handleEditPerson(entryView: AccountEntryView, person_id: string, role: string) {
    this.personService.get(person_id).then(person => {
      let modal_ref_edit = this.modal.open(ModalEditPersonOnEntryComponent, { size: 'lg' });
      modal_ref_edit.componentInstance.person = person;
      modal_ref_edit.componentInstance.role = role;
      modal_ref_edit.componentInstance.saved$.subscribe((updated_person: Person) => {
        this.personService.update(updated_person).then(updated_person => {
          if (role == 'OWNER') { entryView.ownerName = (updated_person.first_name + ' ' + updated_person.last_name).trim(); }
          if (role == 'TRAINER') { entryView.trainerName = (updated_person.first_name + ' ' + updated_person.last_name).trim(); }
          if (role == 'RIDER') {
            entryView.competitionEntries.forEach(c_ent => {
              if (c_ent.riderPersonId == updated_person.id) {
                c_ent.riderName = (updated_person.first_name + ' ' + updated_person.last_name).trim();
              }
            });
          }
          modal_ref_edit.close();
        }).catch(error => { modal_ref_edit.close(); this.handleError(error); });
      }, error => { modal_ref_edit.close(); this.handleError(error); });

      modal_ref_edit.componentInstance.change$.subscribe(() => {
        modal_ref_edit.close();
        this.handleChoosePerson(entryView, person_id, role);
      });
    }).catch(error => { this.handleError(error); });
  }

  handleEditHorse(entryView: AccountEntryView) {
    this.horseService.get(entryView.horseId).then(horse => {
      let modal_ref_edit = this.modal.open(ModalEditHorseOnEntryComponent, { size: 'lg' });
      modal_ref_edit.componentInstance.horse = horse;
      modal_ref_edit.componentInstance.change$.subscribe(() => { modal_ref_edit.close(); this.handleChooseHorse(entryView); });
      modal_ref_edit.componentInstance.save$.subscribe(horse => {
        this.horseService.update(horse).then(updated_horse => {
          entryView.horseId = updated_horse.id;
          entryView.horseName = updated_horse.name;
          modal_ref_edit.close();
        }).catch(error => { this.handleError(error); });
      });
    }).catch(error => { this.handleError(error); });
  }

  handleChooseHorse(entryView: AccountEntryView) {
    let modal_ref_horse = this.modal.open(ModalChooseHorseComponent, { size: 'lg' });
    modal_ref_horse.componentInstance.horse_selected$.subscribe((selected_horse: Horse) => {
      modal_ref_horse.close();
      this.pendingHorseShowEntryService.updateHorseOnEntry(entryView.entryId, selected_horse.id).then(response => {
        if (response) { entryView.horseId = selected_horse.id; entryView.horseName = selected_horse.name; }
      }).catch(error => { this.handleError(error); });
    }, error => { this.handleError(error); });
    modal_ref_horse.componentInstance.add_new_selected$.subscribe(() => {
      modal_ref_horse.close();
      this.addHorseViewService.doAddHorse().then(new_horse => {
        const afterAdd = (horse: Horse) => {
          entryView.horseId = horse.id; entryView.horseName = horse.name;
        };
        if (new_horse.id) {
          afterAdd(new_horse);
        } else {
          this.horseService.create(new_horse).then(afterAdd).catch(error => { this.handleError(error); });
        }
      }).catch(error => { this.handleError(error); });
    }, error => { this.handleError(error); });
  }

  handleChoosePerson(entryView: AccountEntryView, person_id: string, role: string) {
    let modal_ref_person = this.modal.open(ModalChoosePersonComponent, { size: 'lg' });
    modal_ref_person.componentInstance.person_selected$.subscribe((selected_person: Person) => {
      if (role == 'OWNER') {
        this.pendingHorseShowEntryService.updatePersonOnEntry(entryView.entryId, selected_person.id, 'OWNER').then(response => {
          if (response) { entryView.ownerPersonId = selected_person.id; entryView.ownerName = (selected_person.first_name + ' ' + selected_person.last_name).trim(); }
        }).catch(error => { modal_ref_person.close(); this.handleError(error); });
      }
      if (role == 'TRAINER') {
        this.pendingHorseShowEntryService.updatePersonOnEntry(entryView.entryId, selected_person.id, 'TRAINER').then(response => {
          if (response) { entryView.trainerPersonId = selected_person.id; entryView.trainerName = (selected_person.first_name + ' ' + selected_person.last_name).trim(); }
        }).catch(error => { modal_ref_person.close(); this.handleError(error); });
      }
      if (role == 'RIDER') {
        this.pendingHorseShowEntryService.updatePersonOnEntry(entryView.entryId, selected_person.id, 'RIDER', person_id).then(response => {
          if (response) {
            entryView.competitionEntries.forEach(c_ent => {
              if (c_ent.riderPersonId === person_id) { c_ent.riderPersonId = selected_person.id; c_ent.riderName = (selected_person.first_name + ' ' + selected_person.last_name).trim(); }
            });
          }
        }).catch(error => { modal_ref_person.close(); this.handleError(error); });
      }
      modal_ref_person.close();
    });

    modal_ref_person.componentInstance.add_new_selected$.subscribe(() => {
      modal_ref_person.close();
      this.addPersonViewService.doAddPerson().then(new_person => {
        this.personService.create(new_person).then(person => {
          if (role == 'OWNER') {
            this.pendingHorseShowEntryService.updatePersonOnEntry(entryView.entryId, person.id, 'OWNER').then(response => {
              if (response) { entryView.ownerPersonId = person.id; entryView.ownerName = (person.first_name + ' ' + person.last_name).trim(); }
            }).catch(error => { this.handleError(error); });
          }
          if (role == 'TRAINER') {
            this.pendingHorseShowEntryService.updatePersonOnEntry(entryView.entryId, person.id, 'TRAINER').then(response => {
              if (response) { entryView.trainerPersonId = person.id; entryView.trainerName = (person.first_name + ' ' + person.last_name).trim(); }
            }).catch(error => { this.handleError(error); });
          }
          if (role == 'RIDER') {
            this.pendingHorseShowEntryService.updatePersonOnEntry(entryView.entryId, person.id, 'RIDER', person_id).then(response => {
              if (response) {
                entryView.competitionEntries.forEach(c_ent => {
                  if (c_ent.riderPersonId === person_id) { c_ent.riderPersonId = person.id; c_ent.riderName = (person.first_name + ' ' + person.last_name).trim(); }
                });
              }
            }).catch(error => { this.handleError(error); });
          }
        }).catch(error => { this.handleError(error); });
      }).catch(error => { this.handleError(error); });
    });
  }

  handleEditCompetitions(entryView: AccountEntryView) {
    let modal_edit = this.modal.open(ModalEditCompetitionsComponent, { size: 'lg' });
    modal_edit.componentInstance.setHorse_show_entry(entryView);
    modal_edit.componentInstance.pending_competition_entry_added$.subscribe((i_competition_entry: I_competition_entry) => {
      const compEntry = new AccountCompetitionEntryView({});
      compEntry.competitionEntryId = i_competition_entry.id;
      compEntry.competitionTitle = i_competition_entry.competition_number + '. ' + i_competition_entry.competition_name;
      compEntry.riderPersonId = i_competition_entry.rider_person_id;
      compEntry.riderName = i_competition_entry.person_name_rider;
      entryView.competitionEntries.push(compEntry);
    }, error => { modal_edit.close(); this.handleError(error); });

    modal_edit.componentInstance.pending_competition_entry_removed$.subscribe(i_competition_entry => {
      entryView.competitionEntries.forEach((exc__entry, i) => {
        if (exc__entry.competitionEntryId === i_competition_entry.id) { entryView.competitionEntries.splice(i, 1); }
      });
    }, error => { modal_edit.close(); this.handleError(error); });
  }

  handleViewEntry(hs_entry: AccountEntryView) {
    let modal_ref_view = this.modal.open(ModalViewPendingEntryComponent, { size: 'lg' });
    modal_ref_view.componentInstance.entry_id = hs_entry.entryId;
  }

  handleEditPayee(horse_show_name: string, entryView: AccountEntryView) {
    let modal_edit_payee = this.modal.open(ModalEditPayeeOnEntryComponent, { size: 'lg' });
    modal_edit_payee.componentInstance.setHorse_show_entry(entryView);
    modal_edit_payee.componentInstance.horse_show_name = horse_show_name;
    modal_edit_payee.componentInstance.saved$.subscribe(success => {
      if (success) { modal_edit_payee.close(); }
    });
  }

  handlePayBalance(entryView: AccountEntryView) {
    let modal_ref_pay = this.modal.open(ModalPayBalanceComponent, { size: 'lg' });
    modal_ref_pay.componentInstance.setHorse_show_entry(entryView);
    modal_ref_pay.componentInstance.payment_made$.subscribe(receipt => {
      modal_ref_pay.close();
      let modal_ref_receipt = this.modal.open(ModalPaymentReceiptComponent, { size: 'lg' });
      modal_ref_receipt.componentInstance.receipt = receipt;
    }, error => { modal_ref_pay.close(); this.handleError(error); });
  }

  handleEditBillItems(horse_show_name: string, entryView: AccountEntryView) {
    let modal_ref_edit = this.modal.open(ModalEditBillingItemsComponent, { size: 'lg' });
    modal_ref_edit.componentInstance.setHorseShowEntry(entryView);
    modal_ref_edit.componentInstance.horse_show_name = horse_show_name;
    modal_ref_edit.componentInstance.account_items_changed$.subscribe((statement: Statement) => {
      if (entryView.stablingWarningNeeded) {
        statement.summary_bill_items.forEach(item => {
          if (item.categorize_as_stabling && item.quantity > 0) { entryView.stablingOrdered = true; }
        });
      }
      modal_ref_edit.close();
    }, error => { modal_ref_edit.close(); this.handleError(error); });
  }

  handleEditSignatures(horse_show_name: string, entryView: AccountEntryView) {
    let modal_ref_edit = this.modal.open(ModalEditSignaturesOnEntryComponent, { size: 'lg' });
    modal_ref_edit.componentInstance.setHorse_show_entry(entryView);
    modal_ref_edit.componentInstance.horse_show_name = horse_show_name;
  }

  handleDelete(horse_show_name: string, entryView: AccountEntryView) {
    let modal_ref_confirm = this.modal.open(ModalConfirmDialogComponent, { size: 'sm' });
    modal_ref_confirm.componentInstance.title = 'Confirm deletion of ' + entryView.horseName;
    modal_ref_confirm.componentInstance.message = 'Click "YES" to delete your pending entry for ' + entryView.horseName + ' at ' + horse_show_name + '. Click "NO" to keep it.';
    modal_ref_confirm.componentInstance.yes$.subscribe(response => {
      if (response) {
        this.pendingHorseShowEntryService.delete(entryView.entryId).then(response => {
          this.unsubmittedHorseShows.forEach(horse_show => {
            horse_show.entries.forEach((exh_entry, i) => {
              if (exh_entry.entryId === entryView.entryId) { horse_show.entries.splice(i, 1); }
            });
          });
          modal_ref_confirm.close();
        }).catch(error => { modal_ref_confirm.close(); this.handleError(error); });
      }
    }, error => { modal_ref_confirm.close(); this.handleError(error); });
    modal_ref_confirm.componentInstance.no$.subscribe(() => { modal_ref_confirm.close(); });
  }

  handleEditMisc(horse_show_name: string, entryView: AccountEntryView) {
    let modal_ref_edit = this.modal.open(ModalEditMiscOnEntryComponent, { size: 'lg' });
    modal_ref_edit.componentInstance.horse_show_name = horse_show_name;
    modal_ref_edit.componentInstance.setHorse_show_entry(entryView);
    modal_ref_edit.componentInstance.saved$.subscribe(updatedEntryView => {
      entryView = updatedEntryView;
      modal_ref_edit.close();
    }, error => { modal_ref_edit.close(); this.handleError(error); });
  }

  handleSubmitEntries(horseShowView: AccountHorseShowEntriesView) {
    this.submission_in_progress = true;
    this.checkoutService.setHorse_show(horseShowView);
    let horse_show_entry_list: AccountEntryView[] = [];
    horseShowView.entries.forEach(horse_show_entry => {
      if (horse_show_entry.selected) { horse_show_entry_list.push(horse_show_entry); }
    });
    if (horse_show_entry_list.length > 0) {
      this.checkoutService.setHorse_show_entry_list(horse_show_entry_list);
      this.router.navigate(['submit-entries']);
    } else {
      this.submission_in_progress = false;
      this.handleError('You have not selected any entries to submit! Check the box under SELECT for each entry you would like to submit.');
    }
  }

  handleCopy(horseShowView: AccountHorseShowEntriesView, entry: AccountEntryView) {
    let modal_select_shows = this.modal.open(ModalSelectCircuitShowsComponent, { size: 'lg' });
    modal_select_shows.componentInstance.setId(horseShowView.circuitId);
    modal_select_shows.componentInstance.horse_shows_selected$.subscribe(horse_show_list => {
      modal_select_shows.close();
      let modal_copy = this.modal.open(ModalCopyCircuitEntryComponent, { size: 'lg' });
      modal_copy.componentInstance.setParameters(horse_show_list, entry.entryId);
      modal_copy.componentInstance.copy_completed$.subscribe(copied => { modal_copy.close(); location.reload(); });
    });
  }
}
